var data = {
	"body": "<g fill=\"currentColor\"><circle cx=\"12\" cy=\"12\" r=\"2\"/><circle cx=\"12\" cy=\"5\" r=\"2\"/><circle cx=\"12\" cy=\"19\" r=\"2\"/></g>",
	"width": 24,
	"height": 24
};
exports.__esModule = true;
exports.default = data;
